import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { HistoryData } from './history';
import { ClientData } from './client';
import { TrackingProvider, _TRACKING_ENTITIES } from './tracking';

@Injectable()
export class ShopsData {

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private tracking: TrackingProvider,
    private clientData: ClientData
  ) { }

  private action: string = "update";


  public getShopsByClient(client: string): Observable<any[]> {
    return this.afDb.list<any>(`ClientConfig/${client}/shops`).
      valueChanges();
  }

  public getShopsByClientAvailable(client: string): Observable<any[]> {
    return this.afDb.list(`ClientConfig/${client}/shops`, ref => ref.orderByChild('state').equalTo(true)).
      valueChanges();
  }
  /**
  @client: Client ID
  @shop: SHOP ID

  Brings information of catlogs of specific shop
  **/
  /*
  public getDashboardOfShop(client: string,shop: string): Observable<any[]>{
    return this.afDb.list(`Clients/${client}/Catalogs/`, ref => ref.orderByChild('shop').equalTo(shop)).valueChanges().
    then((result)=>{
        console.log(this.result);

    })
    catch((error)=>{reject(error)});
  }*/
  /**
  @client: Client ID
  @shop: Shop ID
  **/
  /*
  public getDashboardOfCLient(client: string,shop: string): Observable<any[]>{
    return this.afDb.list(`Clients/${client}/Catalogs/`, ref => ref.orderByChild('shop').equalTo(shop)).valueChanges();
  }*/


  public getCatalogsOfShop(client: string,shop: string): Observable<any[]>{
    return this.afDb.list(`Clients/${client}/Catalogs/`, ref => ref.orderByChild('shop').equalTo(shop)).valueChanges();
  }



  public createShop(client: string, shop: any) {
    if (!shop.id) {
      this.action = "create";
      shop.id = this.afDb.createPushId();
    } else {
      this.action = "update";
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`ClientConfig/${client}/shops/${shop.id}`)
        .update(shop)
        .then(() => {
          return this.historyData.set(
            `Shop content`,
            "shops",
            this.action,
            shop
          );
        })
        .then(() => {
          // this.clientData.getClientConfig(client).once('value').then(dataInfo => {
          //   this.tracking.trackEntity(_TRACKING_ENTITIES.CLIENT, client, client, dataInfo);
          // });
          resolve(shop);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getClientShopById(clientId: string, comerceId: string): Observable<any> {
    return this.afDb.object<any>(`ClientConfig/${clientId}/shops/${comerceId}`).valueChanges()
  }

}
 // end file



// WEBPACK FOOTER //
// ./src/providers/shops.ts